// Purpose: public, logged-out-reachable notice page rendering the privacy
// notice and terms of use. Rendered inside ExternalShell (see App.tsx).
// Anchors #privacy and #terms for deep links.

import { PRIVACY_NOTICE, TERMS_OF_USE } from '@ast/legal-notices';
import { NoticeRenderer } from '../components/legal/NoticeRenderer.tsx';

export function Notice() {
  return (
    <div className="text-fg-primary">
      <h1 className="text-display-m font-display mb-8">Privacy &amp; Terms</h1>

      <section id="privacy" className="mb-12 scroll-mt-32">
        <h2 className="text-display-s font-display mb-4">{PRIVACY_NOTICE.title}</h2>
        <NoticeRenderer notice={PRIVACY_NOTICE} />
      </section>

      <section id="terms" className="scroll-mt-32">
        <h2 className="text-display-s font-display mb-4">{TERMS_OF_USE.title}</h2>
        <NoticeRenderer notice={TERMS_OF_USE} />
      </section>
    </div>
  );
}
